"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _Modal = _interopRequireDefault(require("../../Modal"));
var _constants = require("../../constants");
var _Toggle = _interopRequireDefault(require("../../helpers/Toggle"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var OptionsModal = function OptionsModal(_ref) {
  var filterOptions = _ref.filterOptions,
    activeFilter = _ref.activeFilter,
    buttonType = _ref.buttonType,
    updateActiveFilter = _ref.updateActiveFilter;
  return /*#__PURE__*/_react["default"].createElement(_Toggle["default"], null, function (_ref2) {
    var on = _ref2.on,
      toggle = _ref2.toggle;
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      text: filterOptions[activeFilter] && filterOptions[activeFilter].text,
      icon: "arrow-down",
      buttonType: buttonType || _constants.BUTTON_TYPES.WHITE,
      onClick: toggle
    }), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
      on: on,
      toggle: toggle
    }, filterOptions && filterOptions.map(function (option, i) {
      return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        className: "justify-start",
        key: option.text + 1,
        text: option.text,
        buttonType: _constants.BUTTON_TYPES.FILTER_LIST_ITEM,
        fullWidth: true,
        iconFlip: true,
        onClick: function onClick() {
          if (updateActiveFilter) updateActiveFilter(i);
          toggle();
        },
        active: activeFilter === i
      });
    })));
  });
};
var _default = exports["default"] = OptionsModal;